import getDataFromCanvas from './getDataFromCanvas';

/**
 * ImageHelper
 */
export default class ImageHelper {

    constructor(options, cb) {

        this.positions = [];
        this.colors = [];

        this.step = options.step;
        this.colorset = options.color;
        this.width = options.width;
        this.height = options.height;
        this.depth = options.depth;
        this.random = options.random;
        this.map = options.url.split('/').pop();

        const img = document.createElement('img');
        img.src = options.url;
        this.img = img;
        
        this.canvas = document.createElement('canvas');
        this.ctx = this.canvas.getContext('2d');

        img.onload = () => {
            this.canvas.width = this.img.width;
            this.canvas.height = this.img.height;

            this.ctx.drawImage(this.img, 0, 0, this.img.width, this.img.height);
            
            const { positions, colors } = getDataFromCanvas(this.canvas, this.step, this.width, this.height, this.depth, this.colorset, this.random);
            this.positions = positions;
            this.colors = colors;
            
            if(cb) cb();
        }
    }

    play() {}
    pause() {}

    update = (options, cb) => {
        this.step = options.step;
        this.colorset = options.color;
        this.width = options.width;
        this.height = options.height;
        this.depth = options.depth;
        this.random = options.random;
        
        const { positions, colors } = getDataFromCanvas(this.canvas, this.step, this.width, this.height, this.depth, this.colorset, this.random);
        this.positions = positions;
        this.colors = colors;
        
        if(cb) cb();
    }

    readCanvas = () => {
        //return getDataFromCanvas(this.canvas, this.step, this.colorset);
        const { positions, colors } = this;
        return  { positions, colors };
    }
}